import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { NotificationService } from "projects/sepidz-web-framework/src/lib/services/notification.service";
import { CausecancelComponent } from "./causecancel/causecancel.component";
import { take, takeUntil } from "rxjs/operators";
import { UpdateClientFactorState } from "../model/update-Client-Factor-State.enum";
import { Observable } from "rxjs";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { Branch, Lookup, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { SuccessOrderComponent } from "./success-order/success-order.component";
import { CallSupportComponent } from "./call-support/call-support.component";
import { SuccessModel } from "./success-order/success.model";
import { NewCustomerOrderComponent } from "../customerorder/newcustomerorder/newcustomerorder.component";
import { Invoice, InvoiceCommand, InvoiceItem } from "../model/invoice.model";
import { OrderService } from "../order.service";
import { Customer, CustomerAddress } from "../../parties/model/customer.model";
import { CustomerFormComponent } from "../../parties/customer/customer-form.component";
import { InvoiceActionService } from "../providers/invoiceaction.service";
import { GridFilter, LookupService } from "../../../../../projects/sepidz-web-framework/src/lib/services";
import { RowState, WebKind } from "../../../../../projects/sepidz-web-framework/src/lib/models/enums";
import { OrderItem } from "../model/orderItemcategory.model";
import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { ReceiptPaymentModel, ReceiptPaymentTypeEnum } from "../model/receiptpayment.model";
import { PaymentMethodEnum } from "../model/paymentmethod.enum";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { DelinoCheckCustomerAddressModel } from "../model/delino-check-customer-address.model";
import { SaleMethodNature } from "../../sales/model/sale-method-branch.model";
import { ClubViewModel } from "../model/smartclub.model";
import { ActivePageEnum } from "../model/activepage.enum";
import * as moment from "moment";
import * as jalaliMoment from "jalali-moment";

@Component({
  selector: "order-online",
  templateUrl: "./orderonline.component.html",
  styleUrls: ["./orderonline.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderonlineComponent extends BaseListComponent implements OnInit {
  @ViewChild("factorList") factorList: KGridComponent;
  public orderItemsColumns: form_control[] = [];
  activeModel: boolean = false;
  dataList: any[] = [];
  masterList: any[] = [];
  currentRow: any;
  selectedFilter: any;
  filterInfo: GridFilter[] = [];
  onFilter: GridFilter[] = [];

  formGroup = new UntypedFormGroup({
    branchFilter: new UntypedFormControl(),
    invoiceFilter: new UntypedFormControl(),
    dateTimeFactorFilter: new UntypedFormControl(),
  });

  invoiceFilter: any[] = [
    {
      key: UpdateClientFactorState.InsertInFactorList,
      title: this.translate("ClientApp.FrontOffice.Order.OrderOnline.NotApproved"),
      count: 0,
      selected: false,
      value: UpdateClientFactorState.InsertInFactorList,
    },
    {
      key: UpdateClientFactorState.PrintToKitchen,
      title: this.translate("ClientApp.FrontOffice.Order.OrderOnline.Invoiced"),
      count: 0,
      selected: false,
      value: UpdateClientFactorState.PrintToKitchen,
    },
    {
      key: UpdateClientFactorState.CancelByCustomer,
      title: this.translate("ClientApp.FrontOffice.Order.OrderOnline.Cancelled"),
      count: 0,
      selected: false,
      value: UpdateClientFactorState.CancelByCustomer,
    },
  ];

  allBranchesExceptCallCenter: Branch[] = [];
  receiptPaymentType: Lookup[];
  currentRowCanNotInsertAgain: boolean;
  accessToDelinoConnection = false;
  constructor(
    private notification: NotificationService,
    public order: OrderService,
    private cd: ChangeDetectorRef,
    private lookupService: LookupService,
    public invoiceAction: InvoiceActionService,
    private tabService: TabularService
  ) {
    super();
    this.NoLog = true;
    this.inputEditorform = NewCustomerOrderComponent;
    this.allBranchesExceptCallCenter = this.order.Branches?.filter((x) => !x.AccessToAllBranches);
  }

  ngOnInit(): void {
    this.apiName = "Delino";
    this.areaName = "RestaurantSale";
    this.setColumns();
    this.init();
    this.getAndAcceptDelinoFactor();
    this.setDefaultBranch();
    const m = moment();
    const now = m.locale("fa").format("YYYY/MM/DD");
    this.formGroup.controls["dateTimeFactorFilter"].setValue(now);
    const jalaliNow = jalaliMoment().locale("fa").format("YYYY/MM/DD");
    this.applyDateFilter(jalaliNow);
    this.lookupService
      .getLookupbyCategory("SALE", "ReceiptPaymentType")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: Lookup[]) => {
        this.receiptPaymentType = data;
      });
    this.tabService.tabItemonRefreshData.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x.includes("Delino")) this.order.setActivePage(ActivePageEnum.OnlineFactor);

      if (x.includes("DelinoFactorId")) {
        const id = x.split("DelinoFactorId:")[1];
        this.order.autoDelinoInvoiceId = +id;
        this.getAndAcceptDelinoFactor();
      }
    });
    this.order.splashFormService.closeLoading();
  }

  private init(): void {
    this.notification.init();
    this.notification.notification$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      if (
        value.Key === "UpdateDelino" ||
        value.Key === "DelinoHasOrder" ||
        (value.Key === "InvoiceChanges" && value.Message === SaleMethodNature.Delivery)
      ) {
        this.getData();
        this.factorList?.refreshData();
        this.cd.markForCheck();
      }
    });
  }

  onRowsSelected(row) {
    if (row && row.OrderItems) {
      this.currentRow = row;
      this.currentRowCanNotInsertAgain = row.ClientFactorStateID === UpdateClientFactorState.PrintToKitchen;
      this.dataList = row.OrderItems as any[];
    }
  }

  protected getData() {
    this.order.getMaxInvoiceCode();
  }

  /// ارسال کد تغییر وضعیت فاکتور
  setClientFactorState(state: UpdateClientFactorState) {
    if (!this.currentRow || !this.currentRow.DelinoId) return;
    this.httpCommonService
      .get(`Delino/SetClientFactorState/${this.currentRow.DelinoId}/${state}`)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: any) => {
          this.getData();
          this.factorList?.refreshData();
          this.order.splashFormService.closeLoading();
        },
        (error) => {
          this.order.splashFormService.closeLoading();
          console.log(error);
        }
      );
  }

  //تغییر مدت زمان پخت و دلیوری
  async updateCookingDeliveryDuration(CookingDuration = 0, DeliveryDuration = 0, invoice: Invoice) {
    if (!this.currentRow || !this.currentRow.DelinoId) return;
    try {
      this.order.splashFormService.openDialog("", "");
      await this.httpCommonService
        .get(`Delino/UpdateCookingDeliveryDuration/${this.currentRow.DelinoId}/${CookingDuration}/${DeliveryDuration}`)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise();
      this.order.splashFormService.closeLoading();
      this.factorList?.refreshData();
      this.order.getMaxInvoiceCode();
    } catch (error) {
      console.log(error);
      this.order.splashFormService.closeLoading();
    }
  }

  setColumns() {
    this.httpCommonService
      .getControlsList(this.apiName.split("/")[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.orignalColumns = data as form_control[];
            this.columns = this.orignalColumns.filter(
              (f) =>
                ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
            );
            this.columns = this.columns.sort((a, b) => a.order - b.order);
            if (this.orignalColumns?.find((x) => x.name === "OrderItems")?.DetailControlModels) {
              this.orderItemsColumns = this.orignalColumns.find((x) => x.name === "OrderItems").DetailControlModels["OrderItems"];
              this.orderItemsColumns = this.orderItemsColumns.sort((a, b) => a.order - b.order);
            }
            this.getData();
            this.cd.markForCheck();
          }
        },
        (error) => console.log(error)
      );
  }

  getDetailControlModels(keyName: string) {
    return [];
  }

  /** تایید سفارش */
  public showSuccessOrder(AutoFactor: any = null): void {
    if (AutoFactor != null) this.currentRow = AutoFactor;
    else if (!this.currentRow || !this.currentRow.DelinoId) return;
    const state = this.currentRow.ClientFactorStateID;
    if (state !== UpdateClientFactorState.InsertInFactorList && state !== UpdateClientFactorState.PrintToKitchen) {
      this.sts.showToast("warning", this.translate("ClientApp.FrontOffice.Order.OrderOnline.ConfirmMessage"), null, 3000);
      return;
    }
    this.order.splashFormService.openDialog("", "");
    const phone = this.getCurrentRowPhone();
    this.httpCommonService
      .getList(`Customer/ReadCustomerByMobile/${phone}`)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (customer: Customer) => {
          try {
            if (customer || AutoFactor) this.handleSaveInvoice(customer, AutoFactor);
            else {
              this.order.splashFormService.closeLoading();
              this.showCreateCustomerComponent()
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe((model: Customer) => {
                  if (model) this.handleSaveInvoice(model, AutoFactor);
                });
            }
          } catch (error) {}
        },
        () => {
          this.order.splashFormService.closeLoading();
        }
      );
  }

  /** درخواست پشتیبانی */
  public showSupport(): void {
    this.dialogService
      .open(CallSupportComponent, { errorMessage: "NotFound!!!" }, { closeOnClickOutside: false })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (typeof res === "number") {
          this.setClientFactorState(res);
        }
      });
  }

  public onEdit($event: any): void {
    this.dialogService.open(
      this.inputEditorform,
      { currentrow: $event, apiName: this.apiName, areaName: this.areaName, label: this.label },
      { autoFocus: true, closeOnClickOutside: true, closeOnEscape: true }
    );
    this.factorList?.refreshData();
  }

  /** کنسلی سفارش */
  public ShowCauseCancel(): void {
    if (!this.currentRow || !this.currentRow.DelinoId) return;
    this.order.splashFormService.openDialog("", "");
    this.dialogService
      .open(CausecancelComponent, { errorMessage: "NotFound!!!" }, { closeOnClickOutside: false })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (typeof res === "number") {
          this.setClientFactorState(res);
          this.factorList?.refreshData();
        } else this.order.splashFormService.closeLoading();
      });
  }

  public newInvoice(invoice: Invoice): Invoice {
    this.setInvoiceHeader(invoice);
    this.order.ChangeBranch(invoice.BranchId);
    this.setInvoiceItems(invoice);
    return invoice;
  }

  public getLinkAddress(): void {
    if (!this.currentRow.AddressLink || this.currentRow.AddressLink === "") {
      this.sts.showToast("warning", this.translate("ClientApp.FrontOffice.Order.OrderOnline.InvoiceAddressLinkEmpty"));
    }
    if (this.currentRow.AddressLink) {
      window.open(this.currentRow.AddressLink, "_blank");
    }
  }

  public onBranchFilterChanged(branches: Branch[]): void {
    if (branches.length) this.filterBranchWithOrOperator(branches);
    else this.onBranchFilterClear();
  }

  public onBranchFilterClear(): void {
    this.onFilter = [];
  }

  public applyDateFilter(value: string): void {
    this.selectedFilter = value;
    this.onFilter = Object.assign([], this.filterInfo);
    if (!value) return;
    const filterCustom: GridFilter = {
      Filed: "ShamsiDateTime",
      Value: value,
      Skip: 0,
      Take: 0,
      Operator: "eq",
      Type: "F",
    };
    this.onFilter.push(filterCustom);
  }

  public setFilter($event): void {
    const key = $event?.value;
    if (this.selectedFilter === key || !$event) {
      this.selectedFilter = null;
      this.onFilter = Object.assign([], this.filterInfo);
      return;
    }
    this.selectedFilter = key;
    this.onFilter = Object.assign([], this.filterInfo);

    switch (key) {
      case UpdateClientFactorState.CancelByCustomer:
        const cancel1: GridFilter = {
          Filed: "ClientFactorStateID",
          Value: UpdateClientFactorState.CancelByCustomer,
          Skip: 0,
          Take: 0,
          Operator: "eq",
          Logic: "or",
          Type: "F",
        };
        const cancel2: GridFilter = {
          Filed: "ClientFactorStateID",
          Value: UpdateClientFactorState.CancelForNoFoodRemain,
          Skip: 0,
          Take: 0,
          Logic: "or",
          Operator: "eq",
          Type: "F",
        };
        const cancel3: GridFilter = {
          Filed: "ClientFactorStateID",
          Value: UpdateClientFactorState.CanceledForAddress,
          Skip: 0,
          Take: 0,
          Logic: "or",
          Operator: "eq",
          Type: "F",
        };
        this.onFilter.push(...[cancel1, cancel2, cancel3]);
        break;

      default:
        const f: GridFilter = {
          Filed: "ClientFactorStateID",
          Value: key,
          Skip: 0,
          Take: 0,
          Operator: "eq",
          Logic: "or",
          Type: "F",
        };
        this.onFilter.push(f);
        break;
    }

    if (this.onFilter.length <= 0) this.onFilter = Object.assign([], this.filterInfo);
  }

  private getCurrentRowPhone(): any {
    return this.currentRow.Mobile !== "" && this.currentRow.Mobile
      ? this.currentRow.Mobile
      : this.currentRow.Tel && this.currentRow.Tel !== ""
      ? this.currentRow.Tel
      : null;
  }

  private getAndAcceptDelinoFactor(): void {
    if (this.order.autoDelinoInvoiceId) {
      this.httpCommonService
        .get("Delino/" + this.order.autoDelinoInvoiceId)
        .pipe(take(1))
        .subscribe((factor: any) => {
          if (factor) this.showSuccessOrder(factor);
        });
    }
  }

  private setDefaultBranch(): void {
    if (this.order.currentSaleMethodNature === this.order.SaleMethodNature.Delivery && this.order.isMultiBranch) {
      const branchId = this.order.formGroup.get("BranchId").value;
      if (branchId) {
        const branch = this.order.Branches.find((x) => x.Id === branchId);
        this.formGroup.get("branchFilter").setValue([branchId]);
        this.onBranchFilterChanged([branch]);
      } else {
        this.onFilter = [];
      }
    }
  }

  private setInvoiceHeader(invoice: Invoice): void {
    const webKind = this.order.WebKinds?.find((x) => x.Code == (this.currentRow?.RegisteredInDelino ? WebKind.Delino : WebKind.Vendo));
    invoice.SaleMethodBranchId = this.order.saleMethodBranch.Id;
    invoice.CustomerId = invoice.Customer.Id;
    invoice.CustomerName = invoice.Customer.DisplayName;
    invoice.CustomerNumber = invoice.Customer?.Number;
    invoice.CustomerLastName = invoice.Customer?.Party?.LastName;
    invoice.CustomerDisplayName = invoice.Customer?.Party?.DisplayName;
    invoice.CustomerTitle = invoice.CustomerTitle;
    invoice.CustomerAddress = invoice.Customer.Addresses?.find((f) => f.Id === invoice.AddressId);
    invoice.CustomerAddres = invoice.CustomerAddress?.Address;
    invoice.PhoneId = invoice.Customer.Numbers?.find((f) => f.IsDefault).Id;
    invoice.PayableTotal = this.currentRow.PayableTotal;
    invoice.ShippingCost = this.currentRow.ShippingCost;
    invoice.CourierShippingCost =
      invoice.CustomerAddress?.Zone?.Branches?.find((x) => x.BranchId == this.currentRow.BranchId)?.CourierShippingCost ?? 0;
    invoice.PackingPrice = this.currentRow.PackingPrice;
    invoice.TotalTax = this.currentRow.TotalTax;
    invoice.Description = this.currentRow.Description;
    invoice.Discount = this.currentRow.Discount || 0;
    invoice.IsDiscountPercent = false;
    invoice.TotalDiscount = this.currentRow.Totaldiscount;
    invoice.WebId = this.currentRow.DelinoId;
    invoice.HasClub = this.currentRow.HasClub;
    invoice.Debit = 0;
    invoice.BranchId = this.currentRow.BranchId;
    invoice.IsPickUp = this.currentRow.IsPickupOrder;
    invoice.PreparationPrintCount = invoice.PreparationPrintCount ?? 0;
    invoice.WebKindId = webKind?.Id;
    invoice.CustomerPrintCount = invoice.CustomerPrintCount ?? 0;
    invoice.Items = [];
    this.setClubOfDelinoFactor(invoice);
    this.setReceiptPayment(invoice);
    this.setSalePriceTypeId(invoice);
    this.setFiscalYearId(invoice);
  }

  private setClubOfDelinoFactor(invoice: Invoice) {
    if (
      this.currentRow?.smartUsedCreditRequestId ||
      this.currentRow?.usedCredit ||
      this.currentRow?.creditUsedRial ||
      this.currentRow?.creditUsedPersent
    ) {
      invoice.ClubCode = this.currentRow.smartUsedCreditRequestId;
      invoice.HasClub = true;
      invoice.ClubViewModel = new ClubViewModel();
      invoice.ClubViewModel.Customer = null;
      invoice.ClubViewModel.usedDiscountPercent = this.currentRow.creditPersent;
      invoice.ClubViewModel.UsedProductDiscount = [];
      invoice.ClubViewModel.UseCreditPrice = this.currentRow.creditUsedRial;
      invoice.ClubViewModel.usedCredit = this.currentRow.usedCredit;
      invoice.Discount += this.currentRow.usedCredit;
      invoice.TotalDiscount = invoice.Discount;
      invoice.ClubViewModel.UsedCreditResponseId = this.currentRow.smartUsedCreditRequestId;
      invoice.ClubViewModel["codeOrMobile"] = invoice.Customer.PhoneNumber;
      invoice.ClubViewModel.ClubTotalDiscount = this.currentRow.usedCredit;
      invoice.ClubViewModel.DiscountPrice = this.currentRow.creditPersent;
    }
  }

  private setInvoiceItems(invoice: Invoice): void {
    const Items = this.order.itemCategoryList[0].Items;
    for (let index = 0; index < this.currentRow.OrderItems?.length; index++) {
      const ele = this.currentRow.OrderItems[index];
      let findItem: OrderItem;
      Items.forEach((element: OrderItem) => {
        if (element.Id === ele.ItemId) {
          findItem = Object.assign({}, element);
        }
        if (!findItem && element.ItemChild?.length > 0) {
          element.ItemChild?.forEach((chl: OrderItem) => {
            if (chl.Id === ele.ItemId) {
              findItem = Object.assign({}, chl);
            }
          });
        }
      });
      if (!findItem) {
        this.sts.showToast(
          "danger",
          this.translate("ClientApp.FrontOffice.Order.OrderOnline.Item") +
            " " +
            ele.Title +
            " " +
            this.translate("ClientApp.FrontOffice.Order.OrderOnline.HasNotItem")
        );
        this.order.splashFormService.closeLoading();
        throw new Error(ele.Title + " " + this.translate("ClientApp.FrontOffice.Order.OrderOnline.HasNotItem"));
      }
      const item = new InvoiceItem();
      item.Index = 0;
      item.ApplyTax = !!ele.ApplyTax;
      item.Tax = ele.Tax ?? 0;
      item.Toll = ele.Toll ?? 0;
      item.Quantity = ele.Quantity ?? 0;
      item.Description = ele.Description ?? "";
      item.ItemId = ele.ItemId;
      item.RowDiscount = ele.RowDiscount ?? 0;
      item.UnitPrice = ele.UnitPrice ?? 0;
      item.BranchId = this.order.logInBranch.Id;
      item.NewQuantity = ele.Quantity ?? 0;
      item.UnitPrice = ele.UnitPrice ?? 0;
      item.UnitAdditive = item.UnitAdditive ?? 0;
      item.TotalPrice = ele.TotalPrice ?? 0;
      item.UnitDiscount = item.UnitDiscount ?? 0;
      item.AdditiveUnitDiscount = item.AdditiveUnitDiscount ?? 0;
      item.TotalDiscount = item.TotalDiscount ?? 0;
      item.RowDiscountPrice = item.RowDiscountPrice ?? 0;
      item.UnitService = item.UnitService ?? 0;
      item.UnitTax = item.UnitTax ?? 0;
      item.UnitToll = item.UnitToll ?? 0;
      item.RowDiscount = 0;
      item.CategoryId = findItem.CategoryId;
      item.ItemTitle = ele.Title;
      item.CookingTime = findItem.CookingTime;
      invoice.Items.push(item);
    }

    invoice.Items?.forEach((s) => {
      if (s.State != RowState.Delete) {
        invoice.Total += s.UnitPrice * s.Quantity + s.UnitAdditive * s.Quantity;
      }
    });
  }

  private filterBranchWithOrOperator(branches: Branch[]): void {
    if (branches.length > 1) {
      this.filterInfo.forEach((x) => (x.Logic = "and"));
    }
    this.onFilter = Object.assign([], this.filterInfo);
    branches.forEach((branch) => {
      const branchFilter: GridFilter = {
        Filed: "BranchId",
        Value: branch.Id,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      };
      const SaleMethodBranch = this.order.saleMethodList.find(
        (f) => f.BranchId == branch.Id && f.SaleMethodId === this.order.saleMethodBranch.SaleMethodId
      );
      const SaleMethodBranchFilter: GridFilter = {
        Filed: "SaleMethodId",
        Value: SaleMethodBranch.SaleMethodId,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      };
      if (branches.length > 1) {
        branchFilter.Logic = "or";
        SaleMethodBranchFilter.Logic = "or";
      }
      this.onFilter.push(...[branchFilter, SaleMethodBranchFilter]);
    });
  }

  private setReceiptPayment(invoice: Invoice): void {
    invoice.ReceiptPayments = [];
    const defaultReceiptPaymentTypeId = this.receiptPaymentType.find((f) => f.Code == ReceiptPaymentTypeEnum.Receipt).Id;
    const currentBranch = this.order.Branches.find((x) => x.Id == invoice.BranchId);
    const stringPayment = +currentBranch?.PaymentType || +this.order.logInBranch?.PaymentType; //online
    const cashPayment = this.order.paymentMethodTypeLookup?.find((x) => x.PaymentMethodCode === PaymentMethodEnum.Cash).Id;
    const paymentMethodId = this.currentRow.Payment == 1 ? stringPayment : cashPayment;
    const rc = new ReceiptPaymentModel();
    rc.InvoiceId = invoice.Id;
    rc.ReceiptPaymentTypeId = defaultReceiptPaymentTypeId;
    rc.PaymentMethodId = paymentMethodId;
    rc.Amount = invoice.PayableTotal;
    rc.BranchId = invoice.BranchId;
    rc.State = RowState.New;
    invoice.ReceiptPayments.push(rc);
  }

  private setSalePriceTypeId(invoice: Invoice) {
    const findDefaultSalePrice = this.order.saleMethodBranch.SalePriceTypes.find((f) => f.IsDefault);
    if (findDefaultSalePrice) invoice.SalePriceTypeId = findDefaultSalePrice.SalePriceTypeId;
    else invoice.SalePriceTypeId = this.order.salePriceType[0]?.Id;
  }

  private setFiscalYearId(invoice: Invoice): void {
    const authService = this.accountService.authService;
    if (authService.currentFiscalYear) invoice.FiscalYearId = authService.currentFiscalYear.Id;
    else
      authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) invoice.FiscalYearId = x.Id;
      });
  }

  private showCreateCustomerComponent(): Observable<any> {
    let customerModel = new Customer();
    customerModel.Address = this.currentRow.CustomerAddress;
    customerModel.LastName = this.currentRow.CustomerName;
    customerModel.PhoneNumber = this.currentRow.Mobile;
    const address = new CustomerAddress();
    address.Address = this.currentRow.CustomerAddress;
    address.Latitude = this.currentRow.Lat;
    address.Longitude = this.currentRow.Lng;
    address.BranchId = this.currentRow.BranchId;
    address.IsDefault = true;
    address.ShippingCost = this.currentRow.ShippingCost;
    customerModel.Addresses = [address];
    return this.dialogService.open(
      CustomerFormComponent,
      {
        Customer: customerModel,
        apiName: "Customer",
        areaName: "RestaurantSale",
        label: this.translate("ClientApp.FrontOffice.Order.OrderOnline.Customer"),
      },
      { autoFocus: true, closeOnClickOutside: false, closeOnEscape: false }
    );
  }

  private handleSaveInvoice(c: Customer, AutoFactor: any): void {
    this.order.newInvoice(false);
    let invoice = new Invoice();
    invoice.DelinoFactor = true;
    this.order.splashFormService.openDialog("", "");
    this.checkCustomerAddress(c?.Id).subscribe(
      (customer: Customer) => {
        this.currentRow.Lng = this.currentRow.Lng ?? 0;
        this.currentRow.Lat = this.currentRow.Lat ?? 0;
        invoice.AddressId = customer.Addresses.find((x) =>
          this.currentRow.Lng == 0 || this.currentRow.Lat == 0
            ? this.currentRow.CustomerAddress == x.Address
            : x.Longitude?.toFixed(6) == this.currentRow.Lng?.toFixed(6) && x.Latitude?.toFixed(6) == this.currentRow.Lat?.toFixed(6)
        )?.Id;
        invoice.Customer = c;
        this.newInvoice(invoice);
        if (!AutoFactor) this.showSuccessOrderComponentAndSaveInvoice(invoice);
        else this.getCookingAndSendTimeFromItemAndSaveInvoice(invoice);
      },
      () => {
        this.order.splashFormService.closeLoading();
      }
    );
  }

  private checkCustomerAddress(CustomerId: number): Observable<Customer> {
    const payload = new DelinoCheckCustomerAddressModel();
    payload.Lat = this.currentRow.Lat;
    payload.Lng = this.currentRow.Lng;
    payload.CustomerId = CustomerId;
    payload.Address = this.currentRow.CustomerAddress;
    payload.BranchId = this.currentRow.BranchId;
    payload.CustomerName = this.currentRow.CustomerName;
    payload.PhoneNumber = this.currentRow.Mobile;
    payload.ShippingCost = this.currentRow.ShippingCost;
    payload.isPickup = this.currentRow.isPickup;
    return this.httpCommonService.create("Customer/CheckCustomer", payload).pipe(take(1));
  }

  private getCookingAndSendTimeFromItemAndSaveInvoice(invoice: Invoice): void {
    const res = new SuccessModel();
    res.CookingTime = 0;
    res.SendingTime = 0;
    invoice.Items?.forEach((element) => {
      res.CookingTime = element.CookingTime > res.CookingTime ? element.CookingTime : res.CookingTime;
    });
    res.CookingTime = !res.CookingTime ? this.order.logInBranch?.StandardDelayTimeForPreparation : res.CookingTime;
    res.SendingTime = invoice.CustomerAddress?.Zone?.MinutesToDelivery;
    if (this.currentRowCanNotInsertAgain) {
      this.updateCookingDeliveryDuration(+res.CookingTime, +res.SendingTime, invoice).then();
      return;
    }
    this.SaveInvoice(res, invoice);
    this.factorList?.refreshData();
  }

  private showSuccessOrderComponentAndSaveInvoice(invoice: Invoice): void {
    this.order.splashFormService.closeLoading();
    if (!this.currentRow.CookingDuration) {
      const cookingTime = invoice.Items?.sort((a, b) => a.CookingTime - b.CookingTime)[invoice.Items?.length - 1]?.CookingTime;
      this.currentRow.CookingDuration = cookingTime || this.order.logInBranch.StandardDelayTimeForPreparation;
    }
    if (!invoice.IsPickUp && !this.currentRow.DeliveryDuration) {
      const zoneBranch = invoice.CustomerAddress?.Zone?.Branches?.find((x) => x.BranchId === invoice?.BranchId);
      this.currentRow.DeliveryDuration = zoneBranch?.MinutesToDelivery;
    }
    this.dialogService
      .open(SuccessOrderComponent, { errorMessage: "NotFound!!!", model: this.currentRow }, { closeOnClickOutside: false })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: SuccessModel) => {
        if (res) {
          if (this.currentRowCanNotInsertAgain) {
            this.updateCookingDeliveryDuration(+res?.CookingTime, +res?.SendingTime, invoice).then();
            return;
          }
          this.SaveInvoice(res, invoice);
          this.factorList?.refreshData();
        }
      });
  }

  private SaveInvoice(res: SuccessModel, invoice: Invoice): void {
    const tollPercentage = this.order.currentBranch.TollPercentage;
    const packingPrice = invoice.PackingPrice;
    this.order.formGroup.controls["PackingPrice"].setValue(packingPrice);
    this.order.formGroup.controls["Discount"].setValue(invoice.Discount);
    invoice.isPackingDisable = true;
    this.order.currentBranch.TollPercentage = 0;
    this.order.invoice = invoice;
    this.order.calculate();
    this.order.currentBranch.TollPercentage = tollPercentage;
    this.invoiceAction.order = this.order;
    this.invoiceAction.SaveInvoice(InvoiceCommand.PreparationPrint, this.order.invoice);
    this.invoiceAction.saveEnd.pipe(take(1)).subscribe((x) => {
      if (x) {
        this.updateCookingDeliveryDuration(+res?.CookingTime, +res?.SendingTime, invoice).then((x) => {
          this.order.newInvoice(false);
        });
      } else this.order.newInvoice(false);
      if (this.order.autoDelinoInvoiceId) this.order.autoDelinoInvoiceId = null;
    });
  }
}
